import { render, staticRenderFns } from "./Technologiezentren.vue?vue&type=template&id=928116d0&scoped=true"
import script from "./Technologiezentren.vue?vue&type=script&lang=js"
export * from "./Technologiezentren.vue?vue&type=script&lang=js"
import style0 from "./Technologiezentren.vue?vue&type=style&index=0&id=928116d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928116d0",
  null
  
)

export default component.exports